export const DEPENDENT_VALUES = {
  region_id: { location_id: '' },
  group_id: { region_id: '', location_id: '' },
  partner_id: { group_id: '', region_id: '', location_id: '' },
  stat_key: { overdue_days: [] },
};
